export const presencialTreatment = {
  true: 'Sim',
  false: 'Não',
};
